export function formatPrice(amount, currency, intl) {
  const formattedPrice = intl.formatNumber(amount, {
    maximumFractionDigits: 2,
  });
  return !currency || currency === "SEK"
    ? `${formattedPrice} kr`
    : `${formattedPrice} ${currency}`;
}
